import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { GlobalStyles } from "@mui/material";
import Home from "./pages/home";
import Live240921 from "./pages/Live240921";
import { Helmet } from "react-helmet";
import Live250621 from "./pages/Live250621";
import Footer from "./components/Footer";

const theme = createTheme({
  typography: {
    fontFamily: '"Klee One","Klee","sans-serif"',
  },
});

const globalStyles = {
  body: {
    margin: 0,
    padding: 0,
    overflowX: "hidden",
  },
  html: {
    margin: 0,
    padding: 0,
  },
  "#root": {
    margin: 0,
    padding: 0,
  },
};

const AppContent: React.FC = () => {
  const location = useLocation();

  const isHome = location.pathname === "/";

  return (
    <>
      <Helmet>
        <title>吉田雪乃 | シンガーソングライター</title>
        <meta
          name="description"
          content="吉田雪乃公式サイト。シンガーソングライターとしての活動や最新のライブ情報、SNSのリンクなどをチェックできます。"
        />
        <meta
          name="keywords"
          content="吉田雪乃, シンガーソングライター, 音楽, ライブ, Kawaguchi, Shock On, アーティスト, ミュージック"
        />
        <meta name="author" content="吉田雪乃" />
        <meta
          property="og:title"
          content="吉田雪乃 | シンガーソングライター"
        />
        <meta
          property="og:description"
          content="1996年生まれ、元医療機器メーカー設計開発者。2023年から音楽活動を再開。ライブや作品をこちらでチェック！"
        />
        <meta
          property="og:image"
          content="https://yukinoweb-8195e.web.app/images/240921/Cover_ogp.jpg"
        />
        <meta property="og:url" content="https://yukinoweb-8195e.web.app" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="吉田雪乃 | シンガーソングライター"
        />
        <meta
          name="twitter:description"
          content="1996年生まれ、シンガーソングライターとして活動中。最新ライブ情報やプロフィールはここから！"
        />
        <meta
          name="twitter:image"
          content="https://yukinoweb-8195e.web.app/images/240921/Cover_ogp.jpg"
        />
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Live240921" element={<Live240921 />} />
        <Route path="/Live250621" element={<Live250621 />} />
      </Routes>
      {!isHome && <Footer />}
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
